document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelectorAll('[data-quantity-adjust]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.quantityAdjust);
        const minimum = Number(input.min || 1);
        input.value = Math.max(minimum, Number(input.value || 1) + direction);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const price = form.closest('.product-purchase')?.querySelector('[data-product-price]');
    if (!select || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (option?.dataset.price) {
        price.textContent = option.dataset.price;
        const buyPrice = form.querySelector('[data-buy-price]');
        if (buyPrice) buyPrice.textContent = option.dataset.price;
      }
    });
  });

  const header = document.querySelector('[data-site-header]');
  const setHeaderState = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });
});
